export default __webpack_public_path__ + "static/media/weights.390010bd.svg";